import { render } from "./AppTaskPrice.vue?vue&type=template&id=1d88f6a3&scoped=true"
import script from "./AppTaskPrice.vue?vue&type=script&lang=js"
export * from "./AppTaskPrice.vue?vue&type=script&lang=js"

import "./AppTaskPrice.vue?vue&type=style&index=0&id=1d88f6a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d88f6a3"]])

export default __exports__